<!-- View Config Panel - Compact layout with tree dropdown and collapsible sections -->
<div class="config-panel config-panel--compact">
  <!-- View Selection (Primary) -->
  <div class="form-group">
    <label>
      <i class="fa-solid fa-table"></i>
      Select View
      <span class="optional-tag">(or enter entity below)</span>
    </label>
    <mj-tree-dropdown
      #viewDropdown
      [BranchConfig]="ViewCategoryConfig"
      [LeafConfig]="ViewLeafConfig"
      [Value]="ViewIdAsKey"
      [SelectableTypes]="'leaf'"
      [SelectionMode]="'single'"
      [Placeholder]="'Search or browse saved views...'"
      [EnableSearch]="true"
      (SelectionChange)="onViewSelection($event)"
      [class.error]="viewError">
    </mj-tree-dropdown>
    @if (viewError) {
      <span class="form-error">{{ viewError }}</span>
    }
    @if (!viewError && !viewId && !entityName) {
      <span class="form-hint">
        Select a saved view or enter an entity name below
      </span>
    }
    @if (!viewError && viewId) {
      <span class="form-hint form-hint--selected">
        <i class="fa-solid fa-check"></i>
        Selected: {{ viewName }}
      </span>
    }
  </div>

  <!-- Entity Name (Alternative) -->
  <div class="form-group">
    <label for="entityName">
      <i class="fa-solid fa-database"></i>
      Entity Name
      <span class="optional-tag">(alternative to view)</span>
    </label>
    <input
      type="text"
      id="entityName"
      [(ngModel)]="entityName"
      (input)="onEntityChange()"
      placeholder="e.g., Accounts, Contacts, Users"
      class="form-input">
    <span class="form-hint">
      Use this to display all records from an entity without a saved view
    </span>
  </div>

  <!-- Title (Optional) -->
  <div class="form-group">
    <label for="partTitle">
      <i class="fa-solid fa-heading"></i>
      Part Title
      <span class="optional-tag">(optional)</span>
    </label>
    <input
      type="text"
      id="partTitle"
      [(ngModel)]="title"
      (input)="onTitleChange()"
      [placeholder]="viewName || entityName ? 'Default: ' + (viewName || entityName) : 'Enter a custom title'"
      class="form-input">
    <span class="form-hint">Leave empty to use view/entity name as title</span>
  </div>

  <!-- Display Options -->
  <mj-accordion-panel [(Expanded)]="showDisplayOptions" Size="sm">
    <ng-template mjAccordionTitle>
      <i class="fa-solid fa-grip"></i>
      Display Options
    </ng-template>
    <div class="config-section-body">
        <!-- Display Mode -->
        <div class="form-group">
          <label>Display Mode</label>
          <div class="radio-group radio-group--horizontal">
            <label class="radio-option radio-option--compact" [class.selected]="displayMode === 'grid'">
              <input
                type="radio"
                name="displayMode"
                value="grid"
                [(ngModel)]="displayMode"
                (change)="onDisplayModeChange()">
              <span class="radio-mark"></span>
              <span class="radio-label">
                <i class="fa-solid fa-table-cells"></i>
                Grid
              </span>
            </label>
            <label class="radio-option radio-option--compact" [class.selected]="displayMode === 'cards'">
              <input
                type="radio"
                name="displayMode"
                value="cards"
                [(ngModel)]="displayMode"
                (change)="onDisplayModeChange()">
              <span class="radio-mark"></span>
              <span class="radio-label">
                <i class="fa-solid fa-id-card"></i>
                Cards
              </span>
            </label>
            <label class="radio-option radio-option--compact" [class.selected]="displayMode === 'timeline'">
              <input
                type="radio"
                name="displayMode"
                value="timeline"
                [(ngModel)]="displayMode"
                (change)="onDisplayModeChange()">
              <span class="radio-mark"></span>
              <span class="radio-label">
                <i class="fa-solid fa-timeline"></i>
                Timeline
              </span>
            </label>
            <label class="radio-option radio-option--compact" [class.selected]="displayMode === 'map'">
              <input
                type="radio"
                name="displayMode"
                value="map"
                [(ngModel)]="displayMode"
                (change)="onDisplayModeChange()">
              <span class="radio-mark"></span>
              <span class="radio-label">
                <i class="fa-solid fa-map-location-dot"></i>
                Map
              </span>
            </label>
          </div>
          <span class="form-hint">{{ getDisplayModeDescription() }}</span>
        </div>
        <!-- Map Render Mode (only shown when map is selected) -->
        @if (displayMode === 'map') {
          <div class="form-group">
            <label>Map Style</label>
            <div class="radio-group radio-group--horizontal">
              <label class="radio-option radio-option--compact" [class.selected]="mapRenderMode === 'point'">
                <input type="radio" name="mapRenderMode" value="point"
                  [(ngModel)]="mapRenderMode" (change)="onOptionChange()">
                <span class="radio-mark"></span>
                <span class="radio-label">
                  <i class="fa-solid fa-map-pin"></i>
                  Points
                </span>
              </label>
              <label class="radio-option radio-option--compact" [class.selected]="mapRenderMode === 'choropleth'">
                <input type="radio" name="mapRenderMode" value="choropleth"
                  [(ngModel)]="mapRenderMode" (change)="onOptionChange()">
                <span class="radio-mark"></span>
                <span class="radio-label">
                  <i class="fa-solid fa-earth-americas"></i>
                  Regions
                </span>
              </label>
              <label class="radio-option radio-option--compact" [class.selected]="mapRenderMode === 'heatmap'">
                <input type="radio" name="mapRenderMode" value="heatmap"
                  [(ngModel)]="mapRenderMode" (change)="onOptionChange()">
                <span class="radio-mark"></span>
                <span class="radio-label">
                  <i class="fa-solid fa-fire"></i>
                  Heatmap
                </span>
              </label>
            </div>
          </div>
        }
        <!-- Selection Options -->
        <div class="form-group">
          <div class="checkbox-group checkbox-group--compact">
            <label class="checkbox-option checkbox-option--compact">
              <input
                type="checkbox"
                [(ngModel)]="allowModeSwitch"
                (change)="onOptionChange()">
              <span class="checkbox-mark"></span>
              <span class="checkbox-label">Allow Mode Switch</span>
            </label>
            <label class="checkbox-option checkbox-option--compact">
              <input
                type="checkbox"
                [(ngModel)]="enableSelection"
                (change)="onOptionChange()">
              <span class="checkbox-mark"></span>
              <span class="checkbox-label">Enable Selection</span>
            </label>
          </div>
        </div>
        <!-- Selection Mode -->
        @if (enableSelection) {
          <div class="form-group">
            <label for="selectionMode">Selection Mode</label>
            <select
              id="selectionMode"
              class="form-select"
              [(ngModel)]="selectionMode"
              (change)="onSelectionModeChange()">
              <option value="single">Single Selection</option>
              <option value="multiple">Multiple Selection</option>
            </select>
          </div>
        }
    </div>
  </mj-accordion-panel>

  <!-- Advanced Filtering -->
  <mj-accordion-panel [(Expanded)]="showAdvancedOptions" Size="sm">
    <ng-template mjAccordionTitle>
      <i class="fa-solid fa-filter"></i>
      Advanced Filtering
    </ng-template>
    <div class="config-section-body">
        <!-- Extra Filter -->
        <div class="form-group">
          <label for="extraFilter">
            Extra Filter
          </label>
          <input
            type="text"
            id="extraFilter"
            [(ngModel)]="extraFilter"
            (input)="onFilterChange()"
            placeholder="e.g., Status = 'Active'"
            class="form-input">
          <span class="form-hint">
            SQL WHERE clause to filter records (applied in addition to view filters)
          </span>
        </div>
    </div>
  </mj-accordion-panel>
</div>
